import {
    DeleteHotInfoParams,
    GetHotInfoByIdParams,
    GetHotInfoLanguagesParams,
    GetHotInfoTrackIdParams,
    SaveHotInfoTrackParams,
} from "../types/requestInputs";
import {
    GetHotInfoByIdResponse,
    GetHotInfoLanguagesResponse,
    GetHotInfoTrackIdResponse,
    SaveHotInfoTrackResponse,
} from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { fetchAPI } from "./utils";

// Get Hot Info by Track ID
export const getHotInfoTrackId = async ({
    token,
    trackId,
}: GetHotInfoTrackIdParams): Promise<GetHotInfoTrackIdResponse> => {
    return fetchAPI<GetHotInfoTrackIdResponse>("/get-hot-info-track-id", "POST", { trackId }, token);
};

// Delete a Hot Info entry
export const deleteHotInfo = async ({ token, hotInfoId }: DeleteHotInfoParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-hot-info", "POST", { hotInfoId }, token);
};

// Save a Hot Info track entry
export const saveHotInfoTrack = async ({
    token,
    trackId,
    id,
    type,
    lat,
    lng,
    name,
    website,
    phone,
    language,
    pictures,
    status,
    position,
}: SaveHotInfoTrackParams): Promise<SaveHotInfoTrackResponse> => {
    return fetchAPI<SaveHotInfoTrackResponse>(
        "/save-hot-info",
        "POST",
        { trackId, id, type, lat, lng, name, website, phone, language, pictures, status, position },
        token,
    );
};

// Get available languages for a Hot Info entry
export const getHotInfoLanguages = async ({
    token,
    hotinfoId,
}: GetHotInfoLanguagesParams): Promise<GetHotInfoLanguagesResponse> => {
    return fetchAPI<GetHotInfoLanguagesResponse>("/get-hot-info-languages", "POST", { hotinfoId }, token);
};

// Get Hot Info details by ID and language
export const getHotInfoById = async ({
    token,
    hotinfoId,
    language,
}: GetHotInfoByIdParams): Promise<GetHotInfoByIdResponse> => {
    return fetchAPI<GetHotInfoByIdResponse>("/get-hot-info-id", "POST", { hotinfoId, language }, token);
};
